import { Component, inject, OnInit } from '@angular/core';
import { AdminService } from '@banyan/modules/admin/services/admin.service';

@Component({
  selector: 'app-admin-settings',
  templateUrl: './admin-settings.component.html',
  styleUrl: './admin-settings.component.scss',
})
export class AdminSettingsComponent implements OnInit{
    adminService = inject(AdminService);
    activeTab: string = 'need-captures';

    ngOnInit(): void {
      this.adminService.getSettings();
    }

    selectTab(tab: string) {
      this.activeTab = tab;
    }
}
